module.exports = __webpack_public_path__ + "static/media/armorQuestion.bfcdbb24.png";